<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>

    <v-spacer></v-spacer>

    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-row>
      <v-card-title></v-card-title>
      <v-col cols="12" sm="6" md="2">
        <template>
          <v-autocomplete
              :items="doctors"
              color="white"
              item-text="dr_name"
              item-key="id"
              label="Doctor List"
              v-on:change="getReports()"
              v-model="searchParam.doctor"
              cols="3"
              sm="6"
              return-object
              :loading="isLoading"
              outlined
              dense
              hide-details
          ></v-autocomplete>
        </template>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="date"
                label="Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
            ></v-text-field>
          </template>

          <v-date-picker
              v-model="date"
              @input="menu2 = false"
              @click:date="dateSelect"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" sm="6" md="2">
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            hide-details
            outlined
            dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="1">
        <v-btn depressed color="primary" v-on:click="printList">Print</v-btn>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-btn depressed color="primary" v-on:click="newDialog = true"
        >Add New Counseling</v-btn
        >
      </v-col>
      <v-col cols="12" sm="6" md="1">
        <v-btn depressed color="primary" v-on:click="viewDialog = true"
        >View Counseling</v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-card-title>Prescription Patients: Followup </v-card-title>
        <v-data-table
            :headers="prescriptionHeaders"
            :items="prescriptionDesserts"
            class="elevation-1"
            :search="search"
            dense
            mobile-breakpoint="0"
            :loading="loadingstatus"
            loading-text="Loading... Please wait"
        >
          <template v-slot:item.patient_id="{ item }">
            <span>
              {{ item.patient_id }}<br />
              {{ item.patient.patient_name }}</span
            >
          </template>
          <template v-slot:item.followup_type="{ item }">
            <span> {{ item.followup_type }} </span>
            <v-chip
                class="ma-2"
                color="primary"
                outlined
                small
                v-if="item.injection_type"
            >
              {{ item.injection_type }}
            </v-chip>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="8">
        <v-card-title>Prescription Patients: OT Advice </v-card-title>
        <v-data-table
            :headers="headers"
            :items="desserts"
            class="elevation-1"
            :search="search"
            dense
            mobile-breakpoint="0"
            :loading="loadingstatus"
            loading-text="Loading... Please wait"
        >
          <template v-slot:item.variant="{ item }">
            <v-chip
                v-if="item.advice && item.advice.variant"
                class="ma-2"
                color="primary"
                outlined
                small
            >
              {{ item.advice.variant }}
            </v-chip>
            <v-chip
                v-if="item.advice && item.advice.variant_1"
                class="ma-2"
                color="primary"
                outlined
                small
            >
              {{ item.advice.variant_1 }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                    @click="getPatientCounseling(item)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ma-2"
                    open
                    prepend-icon="mdi-printer"
                    color="primary"
                    label
                    outlined
                    small
                >
                  <v-icon> mdi-plus </v-icon>
                </v-chip>
              </template>
              <span>Add Comments</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="getReports">Reset</v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <div id="print">
      <v-card-title>OT Counseling Patient: Followup</v-card-title>
      <v-data-table
          :headers="followUpHeaders"
          :items="followUpDesserts"
          class="elevation-1"
          :search="search"
          dense
          mobile-breakpoint="0"
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
          disable-pagination
          :hide-default-footer="true"
          :item-class="itemRowBackground"
      >
        <template v-slot:item.patients="{ item }">
          <span v-if="item.patient">
            {{ item.patient.patient_name }}
            <br />
            {{ item.patient.patient_phone }}
          </span>
        </template>
        <template v-slot:item.operation.name="{ item }">
          <span v-if="item.operation">{{ item.operation.name }}</span>
          <!-- <v-chip
            v-if="item.operation.name"
            class="ma-2"
            color="error"
            outlined
            small
          >
            {{ item.operation.name }}
          </v-chip> -->
          <v-chip v-if="item.operation_subhead" class="ma-2" color="error" outlined small>
            {{ item.operation_subhead }}
          </v-chip>
        </template>
        <template v-slot:item.variant="{ item }">
          <v-chip v-if="item.variant" class="ma-2" color="primary" outlined small>
            {{ item.variant }}
          </v-chip>
          <v-chip v-if="item.variant_1" class="ma-2" color="primary" outlined small>
            {{ item.variant_1 }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top v-if="item.status == 'Active'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="getOTSchedule(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-printer"
                  color="primary"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-plus </v-icon>
              </v-chip>
            </template>
            <span>Set OT Schedule</span>
          </v-tooltip>
          <v-tooltip top v-if="item.status == 'Active'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="patientReschedule(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-printer"
                  color="orange"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-redo </v-icon>
              </v-chip>
            </template>
            <span>ReSchedule</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="patientDetailsView(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-printer"
                  color="info"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-eye </v-icon>
              </v-chip>
            </template>
            <span>Patient View Details</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="addNote(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-printer"
                  color="warning"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-book </v-icon>
              </v-chip>
            </template>
            <span>Add Note</span>
          </v-tooltip>
          <v-tooltip top v-if="item.user_id == login_user_id && item.status == 'Active'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="deleteSchedule(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-printer"
                  color="red"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-delete-outline </v-icon>
              </v-chip>
            </template>
            <span>Delete Counseling</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="getReports">Reset</v-btn>
        </template>
      </v-data-table>
      <v-col cols="12" sm="6">
        <v-card-title>Summary</v-card-title>
        <v-simple-table dense>
          <tbody>
          <tr>
            <td>OT Advice Patients</td>
            <td>{{ desserts.length }}</td>
          </tr>
          <tr v-for="item in followup_summary" :key="item.id">
            <td>{{ item.followup_type }}</td>
            <td>{{ item.count }}</td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </div>
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="590">
          <v-form @submit.prevent="formSubmit()" ref="form" lazy-validation>
            <v-card>
              <v-card-title class="text-h5"> Patient Counseling: OT </v-card-title>
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody v-if="reschedule">
                  <tr>
                    <td>Patient ID</td>
                    <td>{{ reschedule.patient_id }}</td>
                  </tr>
                  <tr>
                    <td>Patient Name</td>
                    <td>{{ reschedule.patient_name }}</td>
                  </tr>
                  <tr>
                    <td>Patient Phone</td>
                    <td>{{ reschedule.patient_phone }}</td>
                  </tr>
                  <tr>
                    <td>Operation Name</td>
                    <td>
                      <v-chip class="ma-2" color="green" text-color="white">
                        {{ reschedule.advice_name }}
                      </v-chip>
                    </td>
                  </tr>
                  <tr>
                    <td>Eye</td>
                    <td>
                      <v-chip class="ma-2" color="red" text-color="white">
                        {{ reschedule.variant }}
                      </v-chip>
                      <v-chip class="ma-2" color="red" text-color="white">
                        {{ reschedule.variant_1 }}
                      </v-chip>
                    </td>
                  </tr>
                  <tr>
                    <td>Doctor Name</td>
                    <td>
                      <v-chip class="ma-2">
                        {{ reschedule.dr_name }}
                      </v-chip>
                    </td>
                  </tr>
                  <tr>
                    <td>Doctor Note</td>
                    <td>
                      <v-chip class="ma-2">
                        {{ reschedule.note }}
                      </v-chip>
                    </td>
                  </tr>
                  <tr>
                    <td>Referral Doctor Name</td>
                    <td>
                      <v-autocomplete
                          :items="doctors"
                          color="white"
                          item-text="dr_name"
                          item-value="id"
                          label="Referral Doctors"
                          v-model="reschedule.referral_doctor_id"
                          :loading="isLoading"
                          outlined
                          dense
                          hide-details
                      ></v-autocomplete>
                    </td>
                  </tr>
                  <tr>
                    <td>Operation Subhead</td>
                    <td>
                      <v-text-field
                          dense
                          outlined
                          v-model="reschedule.operation_subhead"
                          label="Operation Subhead"
                          solo
                          hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>Type</td>
                    <td>
                      <v-select
                          v-model="reschedule.followup_type"
                          :items="followup_type"
                          label="Type"
                          dense
                          outlined
                          v-on:change="typeChange()"
                          :rules="rules.required"
                      ></v-select>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ followup_text }}</td>
                    <td>
                      <v-menu
                          v-model="menu3"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="reschedule.rescheduledate"
                              label="Followup Date"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              outlined
                              dense
                              :rules="[(v) => !!v || 'Followup Date is required']"
                          ></v-text-field>
                        </template>

                        <v-date-picker
                            v-model="reschedule.rescheduledate"
                            @input="menu3 = false"
                        ></v-date-picker>
                      </v-menu>
                    </td>
                  </tr>

                  <tr>
                    <td>IOL</td>
                    <td>
                      <v-text-field
                          dense
                          outlined
                          v-model="reschedule.iol"
                          label="IOL"
                          hide-details
                          solo
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>IOL Power</td>
                    <td>
                      <v-text-field
                          dense
                          outlined
                          v-model="reschedule.iol_power"
                          label="IOL Power"
                          hide-details
                          solo
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>OT Room</td>
                    <td>
                      <v-select
                          v-model="reschedule.ot_no"
                          :rules="rules.required"
                          :items="ot_rooms"
                          item-text="name"
                          label="OT Rooms"
                          outlined
                          dense
                      ></v-select>
                    </td>
                  </tr>

                  <tr>
                    <td>OT Amount</td>
                    <td>
                      <v-text-field
                          dense
                          outlined
                          v-model="reschedule.ot_amount"
                          label="Amount"
                          hide-details
                          solo
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>Cabin</td>
                    <td>
                      <v-text-field
                          v-model="reschedule.cabine"
                          label="Cabin"
                          dense
                          outlined
                          hide-details
                      ></v-text-field>
                    </td>
                  </tr>

                  <tr>
                    <td>Counselor Note</td>
                    <td>
                      <v-textarea
                          dense
                          outlined
                          v-model="reschedule.comments"
                          label="Note"
                          solo
                          hide-details
                      ></v-textarea>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      <!-- <v-checkbox v-model="reschedule.ot_schedule">
                      <template v-slot:label>
                        <div>Create OT Schedule</div>
                      </template>
                    </v-checkbox> -->
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed color="warning" text @click="dialog = false">
                  Cancel
                </v-btn>
                <v-btn depressed color="primary" text @click="formSubmit"> SAVE </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="addNotedialog" persistent max-width="590">
          <v-form @submit.prevent="formSubmit()" ref="form" lazy-validation>
            <v-card>
              <v-card-title class="text-h5"> Patient Counseling: Add Note </v-card-title>
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody v-if="reschedule">
                  <tr>
                    <td>Patient ID</td>
                    <td>{{ reschedule.patient_id }}</td>
                  </tr>
                  <tr>
                    <td>Patient Name</td>
                    <td>{{ reschedule.patient_name }}</td>
                  </tr>
                  <tr>
                    <td>Patient Phone</td>
                    <td>{{ reschedule.patient_phone }}</td>
                  </tr>

                  <tr>
                    <td>Counselor Note</td>
                    <td>
                      <v-textarea
                          dense
                          outlined
                          v-model="reschedule.comments"
                          label="Note"
                          solo
                          hide-details
                      ></v-textarea>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed color="warning" text @click="addNotedialog = false">
                  Cancel
                </v-btn>
                <v-btn depressed color="primary" text @click="formSubmit"> SAVE </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="newDialog" persistent max-width="590">
          <v-form @submit.prevent="formSubmit()" ref="form" lazy-validation>
            <v-card>
              <v-card-title class="text-h5"> Patient Counseling: OT Advice </v-card-title>
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody v-if="reschedule">
                  <tr>
                    <td>Patient ID</td>
                    <td>
                      <v-text-field
                          v-model="reschedule.patient_id"
                          outlined
                          dense
                          v-on:change="getPatient(reschedule.patient_id)"
                          :rules="rules.required"
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>Patient Name</td>
                    <td>{{ reschedule.patient_name }}</td>
                  </tr>
                  <tr>
                    <td>Patient Phone</td>
                    <td>{{ reschedule.patient_phone }}</td>
                  </tr>
                  <tr>
                    <td>Operation Name</td>
                    <td>
                      <v-autocomplete
                          :items="operations"
                          color="white"
                          item-text="name"
                          item-value="id"
                          label="Operation List"
                          v-on:change="getReports()"
                          v-model="reschedule.related_id"
                          cols="3"
                          sm="6"
                          :loading="isLoading"
                          outlined
                          dense
                          :rules="rules.required"
                      ></v-autocomplete>
                    </td>
                  </tr>
                  <tr>
                    <td>Operation Subhead</td>
                    <td>
                      <v-text-field
                          dense
                          outlined
                          v-model="reschedule.operation_subhead"
                          label="Operation Subhead"
                          solo
                          hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>Eye</td>
                    <td>
                      <v-row>
                        <v-checkbox value="Right Eye" v-model="reschedule.variant">
                          <template v-slot:label>
                            <div>Right Eye</div>
                          </template>
                        </v-checkbox>
                        <v-checkbox value="Left Eye" v-model="reschedule.variant_1">
                          <template v-slot:label>
                            <div>Left Eye</div>
                          </template>
                        </v-checkbox>
                      </v-row>
                    </td>
                  </tr>
                  <tr>
                    <td>Doctor Name</td>
                    <td>
                      <v-autocomplete
                          :items="doctors"
                          color="white"
                          item-text="dr_name"
                          item-value="id"
                          label="Doctor List"
                          v-model="reschedule.doctor_id"
                          :loading="isLoading"
                          outlined
                          dense
                          :rules="rules.required"
                      ></v-autocomplete>
                    </td>
                  </tr>
                  <tr>
                    <td>Referral Doctor Name</td>
                    <td>
                      <v-autocomplete
                          :items="doctors"
                          color="white"
                          item-text="dr_name"
                          item-value="id"
                          label="Referral Doctors"
                          v-model="reschedule.referral_doctor_id"
                          cols="3"
                          sm="6"
                          :loading="isLoading"
                          outlined
                          dense
                          hide-details
                      ></v-autocomplete>
                    </td>
                  </tr>

                  <tr>
                    <td>Type</td>
                    <td>
                      <v-select
                          v-model="reschedule.followup_type"
                          :items="followup_type"
                          label="Type"
                          dense
                          outlined
                          v-on:change="typeChange()"
                          solo
                          :rules="rules.required"
                      ></v-select>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ followup_text }}</td>
                    <td>
                      <v-menu
                          v-model="menu3"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="reschedule.rescheduledate"
                              label="Followup Date"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              outlined
                              dense
                              hide-details
                              solo
                          ></v-text-field>
                        </template>

                        <v-date-picker
                            v-model="reschedule.rescheduledate"
                            @input="menu3 = false"
                        ></v-date-picker>
                      </v-menu>
                    </td>
                  </tr>
                  <tr>
                    <td>IOL</td>
                    <td>
                      <v-autocomplete
                          label="IOL"
                          v-model="reschedule.iol"
                          :items="iol_list"
                          item-text="name"
                          item-value="id"
                          dense
                          outlined
                      ></v-autocomplete>
                    </td>
                  </tr>
                  <tr>
                    <td>IOL Power</td>
                    <td>
                      <v-text-field
                          dense
                          outlined
                          v-model="reschedule.iol_power"
                          label="IOL Power"
                          hide-details
                          solo
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>OT Room</td>
                    <td>
                      <v-select
                          v-model="reschedule.ot_no"
                          :rules="[(v) => !!v || 'Item is required']"
                          :items="ot_rooms"
                          item-text="name"
                          label="OT Rooms"
                          outlined
                          dense
                      ></v-select>
                    </td>
                  </tr>
                  <tr>
                    <td>OT Amount</td>
                    <td>
                      <v-text-field
                          dense
                          outlined
                          v-model="reschedule.ot_amount"
                          label="Amount"
                          hide-details
                          solo
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>Cabin</td>
                    <td>
                      <v-text-field
                          v-model="reschedule.cabine"
                          label="Cabin"
                          dense
                          outlined
                          hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>Counselor Note</td>
                    <td>
                      <v-textarea
                          dense
                          outlined
                          v-model="reschedule.comments"
                          label="Note"
                          solo
                          hide-details
                      ></v-textarea>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-col>
                <v-autocomplete
                    label="IOL"
                    v-model="reschedule.iol"
                    :items="iol_list"
                    item-text="name"
                    item-value="id"
                    dense
                ></v-autocomplete>
              </v-col>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed color="warning" text @click="newDialog = false">
                  Cancel
                </v-btn>
                <v-btn depressed color="primary" text type="submit"> SAVE </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="viewDialog" persistent max-width="1190">
          <v-card>
            <v-col cols="12" sm="6">
              <v-card-title class="text-h5"> Patient Counseling </v-card-title>
              <v-text-field
                  label="patient id"
                  v-model="history_patient_id"
                  outlined
                  dense
                  v-on:change="getPatientReports"
              >
              </v-text-field>

              <v-chip
                  v-if="history_patient_details"
                  label
                  class="ma-2"
                  small
                  color="success"
                  text-color="white"
              >
                {{ history_patient_details.patient_name }}
              </v-chip>
              <v-chip v-if="history_patient_details" label class="ma-2" small>
                {{ history_patient_details.patient_phone }}
              </v-chip>
              <v-chip v-if="history_patient_details" label class="ma-2" small>
                {{ history_patient_details.patient_dob }}
              </v-chip>
              <v-chip v-if="history_patient_details" label class="ma-2" small>
                {{ history_patient_details.patient_sex }}
              </v-chip>
            </v-col>
            <v-col cols="12">
              <v-card-title>Patient Counseling History</v-card-title>
              <v-data-table
                  :headers="patientHistoryHeaders"
                  :items="patientHistoryDesserts"
                  class="elevation-1"
                  :search="search"
                  dense
              >
                <template v-slot:item.created_at="{ item }">
                  <span>{{ item.created_at }}</span>
                </template>
                <template v-slot:item.operation_subhead="{ item }">
                  <span v-if="item.operation">{{ item.operation.name }}</span
                  ><br />
                  <v-chip
                      v-if="item.operation_subhead"
                      class="ma-2"
                      color="error"
                      outlined
                      small
                  >
                    {{ item.operation_subhead }}
                  </v-chip>
                  <v-chip v-if="item.variant" class="ma-2" color="primary" outlined small>
                    {{ item.variant }}
                  </v-chip>
                  <v-chip
                      v-if="item.variant_1"
                      class="ma-2"
                      color="primary"
                      outlined
                      small
                  >
                    {{ item.variant_1 }} </v-chip
                  ><br />
                  <v-chip class="ma-2" color="primary" outlined small>
                    {{ item.ot_amount }}
                  </v-chip>
                </template>

                <template v-slot:item.followup_type="{ item }">
                  <!-- <v-chip
                    v-if="item.followup_type"
                    class="ma-2"
                    color="info"
                    outlined
                    small
                  > -->
                  {{ item.followup_type }}<br />
                  <!-- </v-chip> -->
                  <v-chip class="ma-2" color="info" outlined small>
                    {{ item.status }}
                  </v-chip>
                </template>
                <template v-slot:item.doctors="{ item }">
                  <span v-if="item.doctor"> {{ item.doctor.dr_name }}<br /> </span>
                  <v-chip class="ma-2" color="info" outlined small>
                    {{ item.counselor.full_name }}
                  </v-chip>
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="getReports">Reset</v-btn>
                </template>
              </v-data-table>
            </v-col>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed color="warning" text @click="viewDialog = false">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../../js/setup";
export default {
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      dialog: false,
      addNotedialog: false,
      newDialog: false,
      viewDialog: false,
      login_user_id: localStorage.getItem("userId"),
      menu2: false,
      menu3: false,
      loadingstatus: true,
      isLoading: true,
      returnUrl: atshq.defaults.headers.common.app_URL,
      search: "",
      doctors: [],
      operations: [],
      ot_rooms: [],
      searchParam: {
        doctor: null,
      },
      followup_text: "Followup Date",
      followup_type: ["OT Confirm", "Later on"],
      iol_list: [],
      reschedule: {
        rescheduledate: new Date().toISOString().substr(0, 10),
        related_id: null,
        comments: null,
        operation_subhead: null,
        followup_type: null,
        ot_amount: 0,
        ot_schedule: false,
        prescription_id: null,
        patient_id: null,
        patient_name: null,
        variant: null,
        variant_1: null,
        doctor_id: null,
        referral_doctor_id: null,
        iol: null,
        iol_power: null,
        ot_no: null,
        cabine: null,
        counseling_id: null,
      },
      rules: {
        required: [(value) => !!value || "Required."],
        nameRules: [
          (v) => !!v || "Patient Name is required",
          (v) => (v && v.length <= 100) || "Name must be less than 100 characters",
        ],
      },
      headers: [
        { text: "Patient ID", value: "patient_id" },
        {
          text: "Patient Name",
          value: "patient.patient_name",
        },
        {
          text: "Advice Name",
          value: "advice.advice_name",
        },
        {
          text: "Eye",
          value: "variant",
        },
        {
          text: "Note",
          value: "advice.note",
        },

        { text: "Doctor", value: "doctor.dr_name" },
        { text: "Prescription Date", value: "prescription_date" },
        { text: "Action", value: "actions", sortable: false },
      ],
      desserts: [],
      followup_summary: [],
      followUpHeaders: [
        { text: "Patient ID", value: "patient_id" },
        {
          text: "Patient info",
          value: "patients",
        },
        {
          text: "Operation Name",
          value: "operation.name",
        },

        {
          text: "Eye",
          value: "variant",
        },

        { text: "Type", value: "followup_type" },
        { text: "Amount", value: "ot_amount" },
        // { text: "Note", value: "comments" },

        // { text: "Date", value: "date" },
        { text: "Doctor", value: "doctor.dr_name" },
        { text: "Followup Date", value: "followup_date" },
        // { text: "Counselor", value: "counselor.last_name" },
        { text: "Action", value: "actions", sortable: false },
      ],
      followUpDesserts: [],
      history_patient_id: null,
      history_patient_details: null,
      patientHistoryHeaders: [
        { text: "Date & time", value: "created_at" },
        {
          text: "Operation Info",
          value: "operation_subhead",
        },
        { text: "Type", value: "followup_type" },
        // { text: "Amount", value: "ot_amount" },
        { text: "Doctor/Counselor", value: "doctors" },
        { text: "Followup Date", value: "followup_date" },
        { text: "Note", value: "comments" },
      ],
      patientHistoryDesserts: [],
      prescriptionHeaders: [
        { text: "Patient Info", value: "patient_id" },
        // {
        //   text: "Patient Name",
        //   value: "patient.patient_name",
        // },
        {
          text: "Type",
          value: "followup_type",
        },
        { text: "Doctor", value: "doctor.dr_name" },
        { text: "Prescription Date", value: "prescription_date" },
        // { text: "Followup Date", value: "next_visit" },
      ],
      prescriptionDesserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "OT Counseling",
          disabled: false,
          href: "/prescription/list",
        },
        {
          text: "Folloup Patients",
          disabled: true,
          href: "",
        },
      ],
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.getReports();
    this.getDoctors();
    this.getFollowupData();
    this.getOperations();
    this.getOtRooms();
    this.getIOL();
    this.getPrescriptionFolloupReports();
  },

  methods: {
    itemRowBackground(item) {
      let $result = "";
      if (item.status == "OT Done") {
        $result = "success";
      }
      return $result;
    },
    patientDetailsView(item) {
      this.viewDialog = true;
      this.history_patient_id = item.patient_id;
      this.getPatientReports();
    },
    addNote(item) {
      this.addNotedialog = true;
      this.reschedule.patient_id = item.patient_id;
      this.reschedule.patient_name = item.patient.patient_name;
      this.reschedule.patient_phone = item.patient.patient_phone;
      this.reschedule.status = "Note";
    },
    getIOL() {
      atshq
          .get("/lens/lens-active-list")
          .then((response) => {
            this.iol_list = response.data.lensProducts;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    getOtRooms() {
      atshq
          .get("/ot-module/ot-room")
          .then((response) => {
            this.ot_rooms = response.data.data;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    getPrescriptionFolloupReports() {
      let drid = this.searchParam.doctor !== null ? this.searchParam.doctor.id : null;

      atshq
          .get(
              "prescriptions/followup-patient?counseling=patient_counseling&date=" +
              this.date +
              "&doctor=" +
              drid
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            this.loadingstatus = false;
            this.prescriptionDesserts = response.data.data;
          })
          .catch((e) => {
            this.errors.push(e);
          });
      this.getFollowupData();
    },
    formSubmit() {
      if (this.$refs.form.validate()) {
        atshq
            .post("ot-module/ot-counsiling", {
              data: this.reschedule,
              user_id: localStorage.getItem("userId"),
            })
            .then((response) => {
              // JSON responses are automatically parsed.
              this.loadingstatus = false;
              this.dialog = false;
              this.newDialog = false;
              this.$noty.success(response.data.messages);
              this.addNotedialog = false;
              // this.getReports();
              this.getFollowupData();
            })
            .catch((e) => {
              // this.errors.push(e);
              console.log(e);
            });
      } else {
        this.$noty.console.error("Please input valid data.");
      }
    },
    typeChange() {
      if (this.reschedule.followup_type == "OT Confirm") {
        this.followup_text = "OT Schedule Date";
        this.reschedule.ot_schedule = true;
      } else {
        this.followup_text = "Followup Date";
        this.reschedule.ot_schedule = false;
      }
    },
    getPatientCounseling(item) {
      this.reschedule.patient_id = item.patient_id;
      this.reschedule.patient_name = item.patient_name;
      this.reschedule.patient_phone = item.patient_phone;
      this.reschedule.advice_name = item.advice_name;
      this.reschedule.related_id = item.related_id;
      this.reschedule.variant = item.variant;
      this.reschedule.variant_1 = item.variant_1;
      this.reschedule.doctor_id = item.doctor_id;
      this.reschedule.referral_doctor_id = null;
      this.reschedule.dr_name = item.dr_name;
      this.reschedule.note = item.note;
      this.dialog = true;
    },
    patientReschedule(item) {
      this.reschedule.patient_id = item.patient_id;
      this.reschedule.patient_name = item.patient.patient_name;
      this.reschedule.patient_phone = item.patient.patient_phone;
      this.reschedule.advice_name = item.operation.name;
      this.reschedule.operation_subhead = item.operation_subhead;
      this.reschedule.related_id = item.operation.id;
      this.reschedule.variant = item.variant;
      this.reschedule.variant_1 = item.variant_1;
      this.reschedule.doctor_id = item.doctor_id;
      this.reschedule.referral_doctor_id = item.referral_doctor_id;
      this.reschedule.dr_name = item.doctor.dr_name;
      this.reschedule.comments = item.comments;

      this.reschedule.iol = item.iol;
      this.reschedule.iol_power = item.iol_power;
      this.reschedule.counseling_id = item.id;
      // this.reschedule = item;
      // console.log(this.reschedule);
      // console.log(item.doctor_id);
      // console.log(item);
      // this.reschedule.push(item);
      this.dialog = true;
    },
    deleteSchedule(item) {
      if (confirm("are you sure?"))
        atshq
            .delete("patients/followup/" + item.id)
            .then((response) => {
              // JSON responses are automatically parsed.
              this.$noty.success(response.data.messages);
              this.loadingstatus = false;
              // this.desserts = response.data.data;
              this.getFollowupData();
            })
            .catch((e) => {
              this.errors.push(e);
            });
      // this.getFollowupData();
    },
    getReports() {
      let drid = this.searchParam.doctor !== null ? this.searchParam.doctor.id : null;
      atshq
          .get("prescriptions/ot-counseling-patient?date=" + this.date + "&doctor=" + drid)
          .then((response) => {
            // JSON responses are automatically parsed.
            this.loadingstatus = false;
            this.desserts = response.data.data;
            this.getPrescriptionFolloupReports();
          })
          .catch((e) => {
            this.errors.push(e);
          });
      this.getFollowupData();
    },
    getPatientReports() {
      atshq
          .get(
              "ot-module/ot-counsiling-history-patient?patient_id=" + this.history_patient_id
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            this.loadingstatus = false;
            this.patientHistoryDesserts = response.data.data;
            this.history_patient_details = response.data.patient_data;
          })
          .catch((e) => {
            this.errors.push(e);
          });
      this.getFollowupData();
    },
    getFollowupData() {
      let drid = this.searchParam.doctor !== null ? this.searchParam.doctor.id : null;
      atshq
          .get(
              "patients/ot-cousiling-followup?date=" +
              this.date +
              "&doctor=" +
              drid +
              "&user_id=" +
              localStorage.getItem("userId")
          )
          .then((response) => {
            this.loadingstatus = false;
            this.followUpDesserts = response.data.data;
            this.followup_summary = response.data.summary;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    getDoctors() {
      atshq
          .get("doctors")
          .then((response) => {
            this.doctors = response.data.data;
            this.loadingstatus = false;
            this.isLoading = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    getOperations() {
      atshq
          .get("operations")
          .then((response) => {
            this.operations = response.data.data;
            this.loadingstatus = false;
            this.isLoading = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    getPatient(patient_id) {
      atshq
          .get("patients/patients/get/" + patient_id)
          .then((response) => {
            this.reschedule.patient_name = response.data.data.patient_name;
            this.reschedule.patient_phone = response.data.data.patient_phone;
            this.loadingstatus = false;
            this.isLoading = false;
          })
          .catch((e) => {
            console.log(e);
            // this.errors.push(e);
          });
    },

    getColor(status) {
      if (status == "void") return "red";
      else return "green";
    },
    _print(item) {
      window.open(
          this.returnUrl + "printdoc/treatment/" + item.patient_id + "/" + item.id
      );
    },

    getOTSchedule(item) {
      window.location.href =
          "/ot-module/schedule-create?patient_id=" +
          item.patient_id +
          "&counseling_id=" +
          item.id;
    },
    invoice_gen(item) {
      this.$router.push("/invoice-create/" + item.patient_id);
      // console.warn(item);
    },
    dateSelect() {
      this.loadingstatus = true;
      this.getReports();
      this.getFollowupData();
      this.getPrescriptionFolloupReports();
    },
    printList() {
      var disp_setting = "toolbar=yes,location=no,";
      disp_setting += "directories=yes,menubar=yes,";
      disp_setting += "scrollbars=yes,width=650, height=600, left=100, top=25";
      var content_vlue = document.getElementById("print").innerHTML;
      var docprint = window.open("", "", disp_setting);
      docprint.document.open();
      docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write(
          '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
      );
      // docprint.document.write(
      //   "<head><title>" + this.doctor.dr_name + " || " + this.date + "</title>"
      // );
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write("font-family:verdana,Arial;color:#000;");

      docprint.document.write(
          "font-family:Verdana, Geneva, sans-serif; font-size:10px;}"
      );
      docprint.document.write(
          "table td, table th {border: 1px solid #ddd;padding: 0px; font-size:9px;}"
      );
      docprint.document.write(
          "table th, table th {padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: #4CAF50;color: white;}"
      );
      docprint.document.write("table {width: 100%;}");

      docprint.document.write("a{color:#000;text-decoration:none;} </style>");
      docprint.document.write('</head><body onLoad="self.print()"><center>');
      docprint.document.write(content_vlue);
      docprint.document.write("</center></body></html>");
      docprint.document.close();
      docprint.focus();
    },
  },
};
</script>
<style scoped>
.success {
  background-color: rgb(215, 215, 44);
}
</style>
